import React, { useState, useEffect } from 'react';
import { api, UserPlanInfo } from '../services/api';
import { PricingPopup } from './PricingPopup';
import './CreditsDisplay.css';

interface CreditsDisplayProps {
  refreshTrigger?: number;
}

export function CreditsDisplay({ refreshTrigger }: CreditsDisplayProps) {
  const [planInfo, setPlanInfo] = useState<UserPlanInfo | null>(null);
  const [loading, setLoading] = useState(true);
  const [showPricingPopup, setShowPricingPopup] = useState(false);

  useEffect(() => {
    fetchPlanInfo();
  }, [refreshTrigger]);

  const fetchPlanInfo = async () => {
    try {
      setLoading(true);
      const info = await api.subscriptions.getMyPlan();
      setPlanInfo(info);
    } catch (err) {
      console.error('Error fetching plan info:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleClick = () => {
    setShowPricingPopup(true);
  };

  const handlePlanChange = () => {
    fetchPlanInfo(); // Refresh plan info after plan change
  };

  if (loading || !planInfo) {
    return (
      <div className="credits-display loading">
        <div className="credits-skeleton"></div>
      </div>
    );
  }

  const percentage = (planInfo.credits.credits_used / planInfo.current_plan.features.credits_monthly) * 100;
  const isLowCredits = planInfo.credits.credits_remaining < 20;

  return (
    <>
      <div 
        className={`credits-display ${isLowCredits ? 'low' : ''}`}
        onClick={handleClick}
      >
        <div className="credits-icon">
          <img 
            src="/credit_icon.png" 
            alt="Credits" 
            width="30" 
            height="30"
          />
        </div>
        <div className="credits-info">
          <div className="credits-value">
            {planInfo.credits.credits_remaining}
          </div>
        </div>
        <div className="credits-progress">
          <div 
            className="credits-progress-bar" 
            style={{ width: `${100 - percentage}%` }}
          />
        </div>
      </div>

      <PricingPopup 
        isOpen={showPricingPopup}
        onClose={() => setShowPricingPopup(false)}
        currentPlanInfo={planInfo}
        onPlanChange={handlePlanChange}
      />
    </>
  );
}

export default CreditsDisplay; 